import TopBarProvider from "../providers/TopBarProvider"
import { Outlet } from "react-router-dom"

const TopBarLayout = () => {
  return <TopBarProvider>
    <Outlet />
  </TopBarProvider>
}

export default TopBarLayout